export const CmsConstants = {
  Animation: {
    fadeOut: 0.278,
  },
  Card: {
    innerRadius: 8,
    outerRadius: 9,
    borderSize: 4,
    innerOffset: 3,
    imageOffset: 5,
    Padding: 10,
    TopLine: 30,
    BottomLine: 28,
    LineSpacing: 0,
    BottomPadding: 6,
    iconPadding: 12,
    ScheduleLine: {
      height: 30,
      width: 200,
    },
  },
  Progress: {
    height: 9,
    verticalPadding: 3,
    horizontalPadding: 15,
    hiddenHeight: 2,
  },
  Ribbon: {
    defaultContentOffset: 62,
    pageContentOffset: 162,
    margin: 20,
    titleOffset: 20,
  },
  Grid: {
    margin: 20,
  },
};
